// NPS is a fixed-shape kind: studios can't edit the question, the
// description, the scale, or the required flag. The builder shows a
// read-only explainer instead of inputs so it's obvious there's
// nothing to fiddle with.

export function NpsConfig(): JSX.Element {
  return (
    <div className="flex flex-col gap-2 rounded-md border border-border bg-surface px-3 py-3 text-xs text-text-muted">
      <p>
        <strong className="text-text">Net Promoter Score</strong> asks players
        on a 1-10 scale how likely they are to recommend your game.
      </p>
      <p>
        Responses of 9 or 10 are <strong>promoters</strong>, 7 or 8 are{' '}
        <strong>passives</strong>, and 0-6 are <strong>detractors</strong>.
        NPS = % promoters - % detractors.
      </p>
      <p>
        The question and scale are fixed so PlayerBase can roll up NPS
        across forms.
      </p>
    </div>
  );
}
